import { render, staticRenderFns } from "./PopulateOrders.vue?vue&type=template&id=0a34adab&lang=pug"
import script from "./PopulateOrders.vue?vue&type=script&lang=js"
export * from "./PopulateOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports